import connection from "../../../../api/config/connection";

const noDetails = (callback, selectValue) => {
  try {
    callback({
      description: selectValue.label,
      place_id: selectValue.place_id,
    });
  } catch (error) {
    callback();
  }
};
export default {
  search: (input, callback, optionsSourceBaseUrl) => {
    const options = {
      method: "GET",
      url: `${optionsSourceBaseUrl}/places`,
      params: {
        searchText: input,
      },
    };

    connection
      .instance()(options)
      .then((response) => {
        try {
          callback(
            response.data.predictions.map((prediction) => {
              return {
                label: prediction.description,
                place_id: prediction.place_id,
              };
            })
          );
        } catch (error) {
          callback();
        }
      })
      .catch(() => callback());
  },

  convertSelectValueToValue: (selectValue, callback, optionsSourceBaseUrl) => {
    const options = {
      method: "GET",
      url: `${optionsSourceBaseUrl}/details`,
      params: {
        placeId: selectValue.place_id,
      },
    };
    connection
      .instance()(options)
      .then((response) => {
        try {
          const location = response.data.result.geometry.location;
          const value = {
            description: selectValue.label,
            place_id: selectValue.place_id,
            lat: location.lat,
            lng: location.lng,
          };
          callback(value);
        } catch (error) {
          noDetails(callback, selectValue);
        }
      })
      .catch(() => noDetails(callback, selectValue));
  },

  convertValueToSelectValue: (value) => {
    const selectValue = value
      ? {
          label: value.description,
          value: JSON.stringify(value),
        }
      : null;
    return selectValue;
  },
};



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/SelectSources/GoogleApi.js